export { MeinSchiffText } from '../../compositions/shared/MeinSchiffText';
